import "./Orders.css"
import OrderCard from "../components/OrderCard";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Toast from '../components/Toast';
import Loader from '../components/Loader';

const OrdersPage = () => {
    const [orders, setOrders] = useState([]);
    const [bankBal, setBankBal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState("");
    const token = window.sessionStorage.getItem("usrtk");

    const navigate = useNavigate();

    const getPendingPayments = useCallback( () => {
        //Get orders pending payment
        setLoading(true);
            fetch(`${process.env.REACT_APP_SERVER_URL}/users/allpendingorders`, {
                    headers: {
                        "authorization": `Bearer ${token}`
                    }
                })
                .then(r => r.json())
                .then(res => {
                    setLoading(false);
                    if (res.type === "error") {
                    Toast.fire({icon: "error", title: res.message})
                    .then(() => navigate('/login'));
                    }
                    setOrders(res.orders);
                    setBankBal(res.bankBal);
                    console.log(res);
                })
                .catch(() => {
                    setLoading(false);
                    Toast.fire({icon: "error", title: "Server error"});
                })

            }, [navigate, token])
    
    useEffect(() => {
        getPendingPayments();

    const token = window.sessionStorage.getItem("usrtk");
      fetch(`${process.env.REACT_APP_SERVER_URL}/users/info`, 
        {
          headers: {
            "authorization": `Bearer ${token}`
          }
        })
      .then(r => r.json())
      .then(res => {
        if (res.type === "error") {
          Toast.fire({icon: "error", title: res.message})
          .then(() => navigate('/login'));
        }
        setUsername(res.username);
      })
      .catch((err) => {
        Toast.fire({icon: "error", title: "Server error"});
      })
              
        const intervalId = setInterval(() => {
            getPendingPayments();
        }, 60000); 

      return () => clearInterval(intervalId);
    }, [navigate, getPendingPayments])

    const payOrder = (id) => {
        const orderObj = orders.find(order => order.refId === id);
        console.log(orderObj);
        setLoading(true);
            fetch(`${process.env.REACT_APP_SERVER_URL}/users/payorder`, {
                    method: "POST",
                    body: JSON.stringify(orderObj),
                    headers: {
                        "authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                })
                .then(r => r.json())
                .then(res => {
                    setLoading(false);
                    if (res.type === "error") {
                        return Toast.fire({icon: "error", title: res.message})
                    }
                    Toast.fire({icon: "success", title: res.message});
                    getPendingPayments();
                })
                .catch((err) => {
                    console.log(err)
                    setLoading(false);
                    Toast.fire({icon: "error", title: "Server error"});
                })
    }

    return (
        <main className="orders">
            {
                loading && <Loader content={""} />
            }
            <div className="main-header">
                <h1>Welcome, {username}</h1>
                <div className="flex">
                <Link to="/" style={{color: "#fff"}}>&lt;&lt; Back home</Link> 

                <Link to="/setpayment" style={{color: "#fff"}}>Set Payment Details</Link> 
                </div><br />
                <button onClick={getPendingPayments}>Refresh</button>
            </div>
            <section className="flex orders-info">
                <article>
                    <p>Bank Balance</p>
                    <h2>{bankBal && Math.floor(bankBal/100).toLocaleString() + "." + ((bankBal % 100) < 10 ? "0" + (bankBal % 100) : (bankBal % 100))}</h2>
                </article>
                <article>
                    <p>Total Unpaid Orders</p>
                    <h2>{orders?.length}</h2>
                </article>
                {/* <article>
                    <p>Wallet Balance</p>
                    <h2>N120,000.00</h2>
                </article> */}
                <article>
                    <p>Pending Orders Amount</p>
                    <h2>N{orders.length > 0 && orders.map(o => o.amount).reduce((init, total) => parseInt(init) + parseInt(total)).toLocaleString()}</h2>
                </article>
            </section>

            {
                orders.length > 0  &&
                <section className="flex">
                    {
                        orders.map(order => {
                            return <OrderCard payorder={payOrder} orderData={order} key={order.refId} />
                        })
                    }
                    
                </section>
            }
        </main>
    )
}

export default OrdersPage;